var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.loading,"z-index":"1000"}},[_c('scale-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }